import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { GET_LINKED_APPLICATION_USERS_QUERY_KEY } from './useLinkedApplicationUsers.query';

const useRemoveApplicationUserQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(
    (username: string) => api.delete(API_URL.APPLICATION_USER_BY_USERNAME(username)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_LINKED_APPLICATION_USERS_QUERY_KEY] });
      },
    }
  );

  return {
    removeApplicationUser: mutateAsync,
    isPending,
  };
};

export default useRemoveApplicationUserQuery;
